import { metadataForComponentEntries, listPresentComponentEntries } from "./listActiveComponentEntries";
import type { ComponentStoreData } from "./types";

/**
 * Filters out falsy and empty string values from the component store data.
 * When `variantMetadata` are present, keeps them index-aligned with the filtered values.
 *
 * @param componentStoreData - The component store data to filter
 * @returns The component store data with the falsy and empty string values filtered out
 */
export function filterComponentStoreDataComponents(
  componentStoreData: ComponentStoreData | null | undefined
): ComponentStoreData {
  if (!componentStoreData) {
    return { components: {} };
  }
  const { components } = componentStoreData;

  if (!components) {
    return { components: {} };
  }

  const filtered: ComponentStoreData = { components: {} };
  const filteredMetadata: ComponentStoreData["variantMetadata"] = {};

  Object.entries(components).forEach(([key, values]) => {
    const entries = listPresentComponentEntries(values ?? []);
    filtered.components[key] = entries.map(({ value }) => value);

    const nextMetadata = metadataForComponentEntries(componentStoreData.variantMetadata?.[key], entries);
    if (nextMetadata) {
      filteredMetadata[key] = nextMetadata;
    }
  });

  if (Object.keys(filteredMetadata).length > 0) {
    filtered.variantMetadata = filteredMetadata;
  }

  return filtered;
}
